import { useAuthStore } from "@src/stores/auth";
import { db } from "@src/services/db";
import "@src/services/echo";

export const ChannelStatusUpdatedListener = () => {
    const auth = useAuthStore();

    const companyId =
        (auth.user as any)?.company_id ??
        (auth.user as any)?.company?.id;

    if (!companyId) return;

    // @ts-ignore
    window.websockets
        .private(`company.${companyId}`)
        .listen(".ChannelStatusUpdatedEvent", async (event: any) => {
            const ch = event?.channel;
            if (!ch?.id) return;

            const channelId = Number(ch.id);
            const status = String(ch.status || "");

            const isDisconnected =
                status === "disconnected" ||
                status === "notLogged" ||
                status === "BOT_STATUS_DISCONNECTED";

            // remover channel no IndexedDB
            if (isDisconnected) {
                await db.channels.delete(channelId);
            } else {
                await db.channels.put({
                    id: channelId,
                    name: ch.name,
                    type: ch.type,
                    token: ch.token,
                    status: status,
                } as any);
            }

            // atualiza todas as sessions que usam esse channel
            const sessions = await db.sessions
                .filter((s: any) => Number(s?.channel?.id) === channelId)
                .toArray();

            if (sessions.length > 0) {
                const updated = sessions.map((s: any) => {
                    const nextChannel = {
                        ...(s.channel || {}),
                        id: channelId,
                        name: ch.name ?? s.channel?.name,
                        type: ch.type ?? s.channel?.type,
                        token: ch.token ?? s.channel?.token,
                        status: status,
                    };

                    return {
                        ...s,
                        channel: nextChannel,
                        updated_at: Date.now(),
                    };
                });
                await db.sessions.bulkPut(updated as any);
            }
        });
};